import React from 'react';
import { CalendarPage } from './CalendarPage';

interface AdminGrafikPageProps {
  onOpenOrder: (id: number) => void;
}

/**
 * AdminGrafikPage — сторінка "Grafik dietetyka" для адміна.
 * Відрізняється від CalendarPage дієтолога:
 * - isEditable=true: адмін може drag-to-create слоти і видаляти їх
 * - Кнопка "Generuj sloty" видима
 * - Призначати пацієнтів до слотів
 */
export const AdminGrafikPage: React.FC<AdminGrafikPageProps> = ({ onOpenOrder }) => {
  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <h1>Grafik dietetyka</h1>
        <div className="muted">
          Zarządzasz grafikiem jako admin. Joanna widzi tylko swój kalendarz (tylko do odczytu).
        </div>
        <div style={{
          display: 'inline-block',
          marginTop: 10,
          background: 'var(--lav)',
          color: 'var(--v900)',
          borderRadius: 10,
          padding: '6px 14px',
          fontSize: 13,
          fontWeight: 600,
        }}>
          🛡️ Tryb administratora · możesz tworzyć i usuwać sloty
        </div>
      </div>

      {/* CalendarPage з isEditable=true для адміна */}
      <CalendarPage onOpenOrder={onOpenOrder} isEditable={true} />
    </div>
  );
};
